function getSpeciesCode(id: number) {
  const species = ['tomato', 'cucumber', 'roses', 'orchids', 'pepper', 'eggplant', 'lettuce'];
  return species[id - 1];
}

export default getSpeciesCode;
